
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer-patients",
      function () {
        return require("private-next-pages/refer-patients.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer-patients"])
      });
    }
  